import { useContestMaintenance } from "../hooks";
import { Modal, Button, Table, Spinner } from "flowbite-react";
import { numberToCurrency } from "@/common/helpers/currency.helpers";
import { STATUS_LABELS_CONTEST_MAINTENANCE } from "@/types/contest-maintenance.type";

interface ContestMaintenanceDetailsModalProps {
  contestMaintenanceId: string;
  show: boolean;
  onClose: () => void;
}

export function ContestMaintenanceDetailsModal({
  contestMaintenanceId,
  show,
  onClose,
}: ContestMaintenanceDetailsModalProps) {
  const { data, isLoading } = useContestMaintenance(contestMaintenanceId);

  return (
    <Modal show={show} onClose={onClose}>
      <Modal.Header className="dark:text-black">Detalhes da Contestação</Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="flex justify-center">
            <Spinner />
          </div>
        ) : (
          <div className="space-y-4">
            <p><span className="font-semibold">Responsável:</span> {data?.data?.createdByName}</p>
            <p><span className="font-semibold">Placa:</span> {data?.data?.contestMaintenance?.licensePlate}</p>
            <p><span className="font-semibold">Status:</span> {STATUS_LABELS_CONTEST_MAINTENANCE[data?.data?.contestMaintenance?.status as string]}</p>
            <p><span className="font-semibold">Mensagem:</span> {data?.data?.contestMaintenance?.message}</p>
            <p><span className="font-semibold">Data de Criação:</span> {new Date(data?.data?.contestMaintenance?.createdAt as Date).toLocaleString()}</p>

            <h3 className="font-semibold">Produtos Contestados</h3>
            <Table striped>
              <Table.Head>
                <Table.HeadCell>Nome</Table.HeadCell>
                <Table.HeadCell>Preço</Table.HeadCell>
              </Table.Head>
              <Table.Body className="divide-y divide-black">
                {data?.data?.products?.map((product) => (
                  <Table.Row key={product._id}>
                    <Table.Cell>{product.name}</Table.Cell>
                    <Table.Cell>{numberToCurrency(product?.price)}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="bg-red-600" onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
